import { SVGProps } from 'react';

function SavedIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="29" height="29" rx="15" fill="#0D863B" />
      <mask id="mask0_1434_6182" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="3" y="3" width="24" height="24">
        <rect x="3" y="3" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1434_6182)">
        <path d="M12.55 17.3L20.575 9.27499C20.8917 8.95832 21.2667 8.79999 21.7 8.79999C22.1333 8.79999 22.5083 8.95832 22.825 9.27499C23.1417 9.59165 23.3 9.96665 23.3 10.4C23.3 10.8333 23.1417 11.2083 22.825 11.525L13.675 20.675C13.3583 20.9917 12.9833 21.15 12.55 21.15C12.1167 21.15 11.7417 20.9917 11.425 20.675L7.17501 16.425C6.85835 16.1083 6.70001 15.7333 6.70001 15.3C6.70001 14.8667 6.85835 14.4917 7.17501 14.175C7.49168 13.8583 7.86668 13.7 8.30001 13.7C8.73335 13.7 9.10835 13.8583 9.42501 14.175L12.55 17.3Z" fill="#FEFEFE" />
      </g>
    </svg>
  );
}

export default SavedIcon;
